'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration', 'AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.NavigationHistory', dependencies).factory('NavigationHistoryService', require('./services/NavigationHistoryService')).controller('NavigationHistoryController', require('./controllers/NavigationHistoryController')).directive('rmNavigationHistory', require('./directives/NavigationHistoryDirective'));